import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMountainCity } from '@fortawesome/free-solid-svg-icons/faMountainCity';
import type { IconProps } from '../../types';

export function MountainCityIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Mountain City',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faMountainCity}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
